// Sink dei contatori: accumulo in memoria per-sessione + UN solo flush
// (increment atomico) su Firebase Realtime DB. Storage piatto → costo ~0.

import { FWSSP_PROBE } from "./config";

const counters: Record<string, number> = {};
let flushed = false;

// Incrementa un contatore. Le chiavi con "/" diventano path annidati su Firebase:
//   "536054/empty" → /fwssp/<day>/536054/empty
export function bump(key: string, n: number = 1): void {
  counters[key] = (counters[key] || 0) + n;
}

function flush(): void {
  if (flushed || !FWSSP_PROBE.dbUrl) return;
  const keys = Object.keys(counters);
  if (!keys.length) return;
  flushed = true;

  const day = new Date().toISOString().slice(0, 10);
  const exp = FWSSP_PROBE.exp || "default";
  const payload: Record<string, any> = {};
  keys.forEach((k) => { payload[k] = { ".sv": { increment: counters[k] } }; });

  try {
    fetch(`${FWSSP_PROBE.dbUrl}/fwssp/${exp}/${day}.json`, {
      method: "PATCH",
      keepalive: true,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }).catch(() => { /* no-op */ });
  } catch { /* no-op */ }
}

// Cattura mirata di campioni grezzi (es. VAST con <Ad> ma senza prezzo).
// Scrittura immediata (POST list-append) con cap per-sessione → volume/cost
// trascurabile perché i casi anomali sono rari.
const sampleCaps: Record<string, number> = {};
export function pushSample(bucket: string, payload: any, maxPerSession: number = 20): void {
  if (!FWSSP_PROBE.dbUrl) return;
  const used = sampleCaps[bucket] || 0;
  if (used >= maxPerSession) return;
  sampleCaps[bucket] = used + 1;

  const day = new Date().toISOString().slice(0, 10);
  const exp = FWSSP_PROBE.exp || "default";
  try {
    fetch(`${FWSSP_PROBE.dbUrl}/fwssp/${exp}/${day}/${bucket}.json`, {
      method: "POST",
      keepalive: true,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }).catch(() => { /* no-op */ });
  } catch { /* no-op */ }
}

// Registra il flush a fine vita pagina (una sola volta).
export function installFlush(): void {
  if (typeof window === "undefined") return;
  window.addEventListener("pagehide", flush, { once: true });
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") flush();
  });
}
